import PropTypes from "prop-types";
import React from "react";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";

const AVATAR_SIZE = "44px";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                display: "block",
                height: AVATAR_SIZE,
                width: AVATAR_SIZE,
                position: "relative",
                borderRadius: "4px",
            },
            $(" svg", {
                position: "absolute",
                top: "0px",
                left: "0px",
                zIndex: 2,
                height: AVATAR_SIZE,
                width: AVATAR_SIZE,
            }),
            $(" svg rect", {
                fill: "rgba(255,255,255, .2)",
            }),
            $(" svg circle", {
                fill: "rgba(255,255,255, .2)",
            }),
            $(".dark svg rect", {
                fill: "rgba(0,0,0, .2)",
            }),
            $(".dark svg circle", {
                fill: "rgba(0,0,0, .2)",
            }),
            $(" svg text", {
                fill: "#fff",
                dominantBaseline: "central",
            }),
            $(" .image", {
                position: "absolute",
                top: "0px",
                left: "0px",
                zIndex: 3,
                height: AVATAR_SIZE,
                width: AVATAR_SIZE,
                borderRadius: "4px",
                backgroundSize: "cover !important",
            }),
            $(".circle .image", {
                position: "absolute",
                borderRadius: "22px",
            })
        );
    }
    return styles;
};

const Avatar = ({ src = "", label, shape = "rect", style = {}, dark = false }) => {
    return (
        <div
            data-test={DATATEST.SITE_HEADER.AVATAR}
            className={(dark ? "dark " : "") + `avatar ${shape}`}
            {...getStyles()}
            style={style}
        >
            <svg className="svg" viewBox="0 0 44 44">
                {shape === "rect" ? (
                    <rect x="0" y="0" width="44" height="44" rx="4" ry="4" />
                ) : (
                    <circle cx="22" cy="22" r="22" />
                )}
                <text x="50%" y="50%" fontSize="20" textAnchor="middle">
                    {label}
                </text>
            </svg>
            {src && (
                <div
                    className="image"
                    style={{
                        background: `url("${src}") no-repeat center center`,
                    }}
                />
            )}
        </div>
    );
};

Avatar.propTypes = {
    src: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.object,
};

export default Avatar;
